import { DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import {
  FwButtonComponent,
  FwDialogActionsComponent,
  FwDialogComponent,
  FwDialogContentComponent,
  FwDialogHeaderComponent,
} from '@flywheel-io/vision';

import { CoreApiService } from '../../core-api.service';
import { downloadFile } from '../../shared/browser.utils';
import { JobLogComponent } from './job-log.component';

@Component({
  selector: 'job-log-dialog',
  template: `
    <fw-dialog width="large">
      <fw-dialog-header>
        <span>Logs for {{ jobName }}</span>
      </fw-dialog-header>
      <fw-dialog-content>
        <job-log [dialogMode]="true" [jobId]="jobId" />
      </fw-dialog-content>
      <fw-dialog-actions>
        <span class="job-id-label"><strong>Job ID:</strong> {{ jobId }}</span>
        <fw-button test-id="download-logs-button" variant="solid" (click)="downloadLogs()">Download</fw-button>
      </fw-dialog-actions>
    </fw-dialog>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      .job-id-label {
        flex: 1;
      }
    `,
  ],
  imports: [
    FwButtonComponent,
    FwDialogActionsComponent,
    FwDialogComponent,
    FwDialogContentComponent,
    FwDialogHeaderComponent,
    JobLogComponent,
  ],
})
export class JobLogDialog {
  private readonly data = inject<{ jobId: string; jobName: string }>(DIALOG_DATA);
  private readonly coreApi = inject(CoreApiService);

  protected jobId: string = this.data.jobId;
  protected jobName: string = this.data.jobName;

  downloadLogs(): void {
    const filename = `${this.jobId}_logs.txt`;
    this.coreApi.jobs.logs.text(this.jobId).subscribe((response) => {
      downloadFile(filename, 'data:text/plain;charset=utf-8,' + encodeURIComponent(response));
    });
  }
}
